import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { CurrencyService } from '@rd/core/services/currency/currency.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { NumberService } from '@rd/core/services/number/number.service';
import { TimeService } from '@rd/core/services/time/time.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { IconOptions, LoyaltyCurrency, LoyaltyProgram } from '@rd/types';
import { RedeemCashSettingService } from '../../services/redeem-cash-setting/redeem-cash-setting.service';

type ComponentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-rcv2-checkout-terms-list',
  templateUrl: './checkout-terms-list.component.html',
  styleUrls: ['./checkout-terms-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RcV2CheckoutTermsListComponent implements OnInit {
  @HostBinding('class.rd-rcv2-checkout-terms-list') componentClass = true;
  @Input() redeemCashLoyaltyProgram: LoyaltyProgram;
  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  flippableIconOptions: IconOptions = {
    flippable: true,
  };

  constructor(
    private currencyService: CurrencyService,
    private iconRegistryService: IconRegistryService,
    private numberService: NumberService,
    private redeemCashSettingService: RedeemCashSettingService,
    private timeService: TimeService,
    private loyaltyProgramHelper: LoyaltyProgramHelper,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
  }

  getComponentRenderState(): ComponentRenderState {
    if (this.redeemCashLoyaltyProgram) {
      return 'content';
    } else {
      return 'loading';
    }
  }

  loyaltyCurrencyTranslationParams(): {
    points_amount: string;
    currency: string;
  } {
    return {
      points_amount: this.numberService.formatNumber(
        // @ts-ignore
        this.redeemCashLoyaltyProgram.transferRate.denomination,
      ),
      currency: this.loyaltyCurrencySelected.name,
    };
  }

  cashAmount(): string {
    const {
      // @ts-ignore
      denomination,
      // @ts-ignore
      exchangeRate,
    } = this.redeemCashLoyaltyProgram.transferRate;
    const minimumCashIncrement = denomination * exchangeRate;

    return this.currencyService.formatCurrency(
      minimumCashIncrement,
      'symbol',
      '1.0-2',
    );
  }

  transferTimeParams(): { duration: string } {
    return {
      duration: this.timeService.timeFromNow(
        this.loyaltyProgramHelper.getCashBackCapability(
          this.redeemCashLoyaltyProgram,
        ).processingDelay,
      ),
    };
  }

  cashReminderTranslationParams(): { loyaltyCurrencyName: string } {
    return {
      loyaltyCurrencyName: this.loyaltyCurrencySelected.shortName,
    };
  }

  minimumPointsTransferTranslationParams(): {
    points_amount: string;
    currency: string;
  } {
    return {
      points_amount: this.numberService.formatNumber(
        // @ts-ignore
        this.redeemCashLoyaltyProgram.transferRate.minimumTransfer,
      ),
      currency: this.loyaltyCurrencySelected.shortName,
    };
  }

  get checkoutReminderMessageKey(): string | null {
    if (
      this.redeemCashSettingService.checkoutPageText &&
      this.redeemCashSettingService.checkoutPageText.checkoutReminderMessage
    ) {
      return this.redeemCashSettingService.checkoutPageText
        .checkoutReminderMessage.translationKey;
    }
    return null;
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('convert-points');
    this.iconRegistryService.registerIcon('minimum-transfer');
    this.iconRegistryService.registerIcon('clock');
  }
}
